import { render, staticRenderFns } from "./group-profile.vue?vue&type=template&id=678b3ad8"
import script from "./group-profile.vue?vue&type=script&lang=js"
export * from "./group-profile.vue?vue&type=script&lang=js"
import style0 from "./group-profile.vue?vue&type=style&index=0&id=678b3ad8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports